export const minTwoDigits = (n) =>  (n < 10 ? '0' : '') + n



// WEBPACK FOOTER //
// ./src/components/helpers/two-digits.js